function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "suitcase");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18 4h-1v15h1c1.1 0 2-0.9 2-2v-11c0-1.1-0.9-2-2-2zM0 6v11c0 1.1 0.899 2 2 2h1v-15h-1c-1.101 0-2 0.9-2 2zM13.5 1.906c-0.681-0.316-1.889-0.906-3.519-0.906-1.633 0-2.8 0.59-3.481 0.906v2.094h-2.5v15h12v-15h-2.5v-2.094zM12 4h-4v-1.336c0.534-0.23 1.078-0.465 1.981-0.465s1.486 0.234 2.019 0.465v1.336z"
});

var SvgSuitcase = function SvgSuitcase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSuitcase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/suitcase.32469cd2.svg";
export { ForwardRef as ReactComponent };